import React, { Component } from 'react';
import { Card, Table, Form, Badge, Input, Button, Progress, Modal } from 'antd';
const {confirm} = Modal

const statusSet = [null, <Badge color="geekblue" text="Submitted" />, <Badge status="processing" text="Running" />, <Badge status="success" text="Success" />, <Badge status="error" text="Failed" />, <Badge color="orange" text="Interrupted" />]

class Search extends Component {
    state = {
        name: ''
    }
    keyChange = e => {
        this.setState({
            name: e.target.value
        })
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.onSearch({
            projectName: this.state.name
        })
    }
    render() {
        return (
            <Form layout="inline" className="pt10 pb10">
                <Form.Item label="Model Name">
                    <Input style={{ width: '300px' }} onChange={this.keyChange} value={this.state.name} placeholder="Fuzzy search by name" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={this.handleSubmit}>Search</Button>
                </Form.Item>
            </Form>
        )
    }
}
const SearchForm = Form.create({ name: 'tenantOrder' })(Search)

class RunningList extends Component {
    state = {
        tableLoading: false,
        searchParams: {},
        sorter: {},
        pagination: {
            current: 1,
            pageSize: 20,
            showTotal: total => `${total} items `,
            total: 0
        },
        data: []
    }

    reLoad = () => {
        let pager = { ...this.state.pagination }
        pager.current = 1
        this.setState({
            pagination: pager
        }, () => {
            this.fetch();
        })
    }

    onSearch = pms => {
        this.setState({
            searchParams: pms
        })
        this.reLoad()
    }

    fetch() {
        const { pagination, searchParams, sorter } = this.state
        this.setState({
            tableLoading: true
        })
        Util.ajax.post('/predict/offline/task/list', {
            ...searchParams,
            ...sorter,
            pageNum: pagination.current,
            pageSize: pagination.pageSize
        }).then(res => {
            pagination.total = res.data.total
            this.setState({
                data: res.data.list,
                pagination,
                tableLoading: false
            })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    handleTableChange = (pagination, filters, sorter) => {
        console.log(pagination, sorter);
        
        const pager = { ...this.state.pagination }
        pager.current = pagination.current
        this.setState({
            pagination: pager,
            sorter: {
                orderBy: sorter.field,
                sort:sorter.order === 'ascend' ? 'asc' : 'desc'
            }
        }, () => {
            this.fetch();
        })
    }

    interrupt = row => {
        confirm({
            title: 'Warning',
            content: 'Confirm interrupt task?',
            okText: 'Confirm',
            okType : 'danger',
            cancelText: 'Cancel',
            onOk: () => {
                Util.ajax.get('/predict/offline/task/interrupt', {
                    id: row.id
                }).then(res => {
                    this.fetch()
                })
            }
        })
    }

    resubmit = row => {
        confirm({
            title: 'Hint',
            content: 'Confirm resubmit task?',
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                Util.ajax.get('/predict/offline/task/submit', {
                    id: row.id
                }).then(res => {
                    this.fetch()
                })
            }
        })
    }

    render() {
        const columns = [
            {
                title: 'Task ID',
                dataIndex: 'id',
                sorter:true,
                defaultSortOrder: 'descend'
            },
            {
                title: 'Model Name',
                dataIndex: 'projectName',
                sorter:true
            },
            {
                title: 'Task Status',
                dataIndex: 'status',
                render: status => status ? statusSet[status] : '',
                sorter:true
            },
            {
                title: 'Calculation Progress',
                dataIndex: 'progress',
                render: (progress, row) => {
                    return (
                        <div>
                            {row.status === 2 && <Progress strokeWidth={16} status="active" percent={progress * 100}></Progress>}
                            {row.status === 3 && <Progress strokeWidth={16} percent={progress * 100}></Progress>}
                            {(row.status === 4 || row.status === 5) && <Progress strokeWidth={16} status="exception" percent={100}></Progress>}
                        </div>
                    )
                }
            },
            {
                title: 'Calculation Duration',
                dataIndex: 'timeCost'
            },
            {
                title: 'Submission Time',
                dataIndex: 'createTime',
                render: time => Util.dateFormat(time),
                sorter:true
            },
            {
                title: 'Actions',
                dataIndex: 'status',
                key: 'active',
                align: 'center',
                render: (status, row) => {
                    return status === 2 ? <Button type="danger" onClick={() => this.interrupt(row)}>Interrupt</Button> : (status === 4 || status === 5) ? <Button type="link" onClick={() => this.resubmit(row)}>Resubmit</Button> : ''

                }
            }
        ]

        return (
            <div className="page-content">
                <Card title="Task Running Management" bordered={false} style={{ width: '100%' }}>
                    <SearchForm onSearch={pms => this.onSearch(pms)}></SearchForm>
                    <Table
                        rowKey={record => record.id}
                        columns={columns}
                        loading={this.state.tableLoading}
                        dataSource={this.state.data}
                        pagination={this.state.pagination}
                        onChange={this.handleTableChange}
                    />
                </Card>
            </div>
        );
    }
}

export default RunningList;
